
import { supabase } from '@/integrations/supabase/client';

export class ResearchDeleteService {
  static async deleteResearch(researchId: string): Promise<void> {
    try {
      // Get current user
      const { data: { user }, error: userError } = await supabase.auth.getUser();
      
      if (userError || !user) {
        throw new Error('Authentication required to delete research');
      }

      // First, delete related favorites to avoid foreign key constraints
      await supabase
        .from('research_favorites')
        .delete()
        .eq('research_id', researchId);

      // Then delete the research item itself
      const { error } = await supabase
        .from('research_library')
        .delete()
        .eq('id', researchId)
        .eq('user_id', user.id); // Ensure user can only delete their own research

      if (error) {
        throw error;
      }
    } catch (error) {
      console.error('Error deleting research:', error);
      throw error;
    }
  }
}
